import { FiPlus } from 'react-icons/fi';
import Group from './Group';
import { useTemplateData } from 'src/Context/TemplateData.context';

type ISelectTopic = {};

const SelectTopic = ({}: ISelectTopic) => {
  const { topicGroup, setTopicGroup, setValidationError } = useTemplateData();

  const handleAddGroup = () => {
    setValidationError('');
    setTopicGroup((prev: any) => {
      return [
        ...prev,
        {
          name: '',
          topics: [],
        },
      ];
    });
  };

  return (
    <div className="select_topic">
      <div className="add_group" onClick={handleAddGroup}>
        <FiPlus /> Add a group
      </div>

      <div className="select_topic_container">
        {
          <div className="group_of_topic">
            {topicGroup.map((item, idx) => {
              return <Group key={idx} index={idx} />;
            })}
          </div>
        }
      </div>
    </div>
  );
};

export default SelectTopic;
